export const environment = {
  production: true,
  config: {
    "DATA_API_URL": "https://mcapi.ppm.org",
    "GOOGLE_SIGNIN_CLIENT_ID": "450245815385-1ikpb54teeqpnu12ksqc10n109ms1m09.apps.googleusercontent.com",
  }
};
